import { jsx as n, jsxs as t, Fragment as b } from "react/jsx-runtime";
import E, { useCallback as g } from "react";
import e from "./style.module.less.js";
import { FileIcon as h } from "./file-icon/index.js";
import F from "./file-icon/icons/download-export.svg.js";
import { ContextMenu as I } from "../../../general/context-menu/index.js";
const R = (s) => {
  const { file: r } = s;
  return /* @__PURE__ */ t("div", { className: `${e.fileTextContainer} ${r ? "" : e.full}`, children: [
    /* @__PURE__ */ n(h, { file: r, className: e.icon }),
    /* @__PURE__ */ n("div", { className: e.fileName, children: r == null ? void 0 : r.name })
  ] });
}, S = (s) => {
  var u;
  const {
    file: r,
    receiver: a,
    className: f,
    previewClassName: p,
    receiverOverlayClassName: C,
    senderOverlayClassName: $,
    fixedPositioning: c,
    toggleTimestamp: x,
    getTranslation: m
  } = s, [d, w] = E.useState(null), y = g((o) => o.replace(/(?:\r\n|\r|\n)/g, " "), []), P = g(() => {
    var N;
    const o = ((N = r.url) == null ? void 0 : N.path) ?? "";
    if (o) {
      const l = document.createElement("a");
      l.href = o, l.download = "", document.body.appendChild(l), l.click(), document.body.removeChild(l);
    } else
      console.error("File URL is missing.");
  }, [(u = r == null ? void 0 : r.url) == null ? void 0 : u.path]);
  if (!r)
    return null;
  let i = null;
  const v = /* @__PURE__ */ n(
    "div",
    {
      className: `${e.textContent} ${e.noPreviewContainer} ${a ? e.receiver : e.sender}`,
      children: /* @__PURE__ */ n("div", { className: e.noPreview, children: m("chat.no-preview") })
    }
  );
  return d ? i = v : r.mime.startsWith("image/") && r.url ? i = /* @__PURE__ */ n(
    "div",
    {
      className: `${e.fileImageContainer}
        ${a ? e.receiver : ""}`,
      children: /* @__PURE__ */ n(
        "img",
        {
          src: r.url.path,
          alt: r.name,
          className: e.fileImage,
          onError: () => w(!0)
        }
      )
    }
  ) : r.textContent ? i = /* @__PURE__ */ t(
    "div",
    {
      className: `${e.textContent} ${a ? e.receiver : e.sender}`,
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            className: `${e.bgOverlay} ${a ? C : $}`
          }
        ),
        y(r.textContent)
      ]
    }
  ) : i = v, /* @__PURE__ */ t(b, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: `
        ${e.fileName}
        ${a ? e.receiver : ""}
        ${f ?? ""}
      `,
        onClick: x,
        children: [
          /* @__PURE__ */ n(h, { file: r, className: e.icon }),
          r == null ? void 0 : r.name
        ]
      }
    ),
    !d && /* @__PURE__ */ t(
      "div",
      {
        className: `
        ${e.filePreviewContainer}
        ${a ? e.receiver : ""}
        ${p ?? ""}
      `,
        children: [
          i,
          r.url ? /* @__PURE__ */ n("div", { className: e.contextMenuContainer, children: /* @__PURE__ */ n(
            I,
            {
              items: [
                {
                  label: m("lawyer.download"),
                  onClick: () => P(),
                  icon: /* @__PURE__ */ n(F, { className: e.downloadIcon })
                }
              ],
              className: e.contextMenu,
              fixedPositioning: c,
              positioning: c ? a ? "left" : "right" : void 0
            }
          ) }) : null
        ]
      }
    )
  ] });
};
export {
  R as FileName,
  S as FilePreview
};
